module.exports = __webpack_public_path__ + "img/bg0.91f5546b.png";